import ActionType from 'actions/ActionType'
import { orderBy } from 'lodash'

export default (state = {}, action) => {
  switch (action.type) {
    case ActionType.Data.READ_SUCCESS:
      if (action.entityType === 'inbox') {
        if (action.payload && action.payload.conversation) {
          const conversation = orderBy(
            action.payload.conversation,
            ['utimestamp'],
            ['asc'],
          )
          return {
            ...action.payload,
            conversation /* :
              conversation.sort((a, b) => {
                if (a.utimestamp > b.utimestamp) return -1
                if (b.utimestamp < a.utimestamp) return 1
                return 0
              }) || [], */,
          }
        }
      }
      return state
    case ActionType.Inbox.SELECT_CONTACT:
      return {}
    case ActionType.Inbox.SELECT_CONVERSATION:
      if (!action.payload) {
        return {}
      }
      return state
    default:
      return state
  }
}
